import React from 'react';
import SideNavigation from '../side-navigation';
import Routes from '../../routes';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { cn } from '@/lib/utils';

export default function MainContainer({ withSideNav, isAuthRoute }) {
  const festival = useFestivalWorkspaceStore((s) => s.festival);
  const hasSelectedFestival = Boolean(festival?.festivalId);
  const showSideNav = withSideNav && hasSelectedFestival;

  return (
    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col md:flex-row">
      {showSideNav && (
        <aside className="h-[calc(100vh-4rem)] w-[250px] shrink-0 border-r border-black/[0.08] bg-white/50 backdrop-blur-md md:sticky md:top-16 md:self-start">
          <SideNavigation festival={festival} />
        </aside>
      )}
      <div
        className={cn(
          'flex min-w-0 flex-1 flex-col',
          isAuthRoute
            ? 'min-h-0 overflow-visible'
            : 'bethere-main-scroll min-h-[calc(100vh-4rem)] overflow-y-auto',
        )}
      >
        <div className="box-border mx-auto w-full max-w-[1440px] flex-1 px-4 py-6 md:px-6 md:py-8">
          <Routes />
        </div>
      </div>
    </div>
  );
}
